module.exports = __webpack_public_path__ + "static/sp_checkout_1-d3871fb9b14b15474aac9a9a413ecd2a.jpg";